import React, {FC} from 'react';
import {useSelector} from 'react-redux';
import {legacyModalsApi} from '~/entities/dialogs';
import {RsnButton, RsnDialog} from '~/library/ui-kit';

export interface LoginBiometryStatusModalProps {
    closeAction: () => void;
    callBackBtn?: () => void;
    title?: string;
    context?: string;
    isError?: boolean;
    returnPoint: string;
}

const LoginBiometryStatusModal: FC<LoginBiometryStatusModalProps> = ({
    closeAction,
    callBackBtn,
    title,
    context,
    isError,
    returnPoint,
}) => {
    const loginBiometryStatusModal = useSelector(legacyModalsApi.select('loginSignupPage', 'loginBiometryStatusModal'));

    const closeActionLocal = () => {
        closeAction();
        window.location.href = returnPoint;
    };

    const callBackBtLocal = () => {
        callBackBtn?.();
        window.location.href = returnPoint;
    };

    return (
        <RsnDialog.Controller isOpen={loginBiometryStatusModal} onClose={closeActionLocal}>
            <RsnDialog.Window>
                <RsnDialog.CenteredHeader
                    icon={{
                        element: <RsnDialog.StatusIcon status={isError ? 'alert' : 'check'} />,
                    }}
                >
                    {title}
                </RsnDialog.CenteredHeader>
                <RsnDialog.Body>{context}</RsnDialog.Body>
                <RsnDialog.Footer>
                    <RsnButton.Secondary type='button' onClick={callBackBtLocal}>
                        I got it
                    </RsnButton.Secondary>
                </RsnDialog.Footer>
            </RsnDialog.Window>
        </RsnDialog.Controller>
    );
};

export default LoginBiometryStatusModal;
